import type { AgentExtras, ChatAttachment, MentionRef } from '@/types/editor';
import { getModelById } from './models';

export function modelSupportsVision(modelId: string): boolean {
  return getModelById(modelId)?.vision ?? false;
}

export function composeAgentExtras(mentions: MentionRef[], attachments: ChatAttachment[]): AgentExtras {
  const imageUrls = attachments
    .filter((a) => a.kind === 'image' && a.status === 'ready' && a.url)
    .map((a) => a.url as string);
  const docTexts = attachments
    .filter((a) => a.kind === 'doc' && a.status === 'ready' && typeof a.text === 'string')
    .map((a) => ({ name: a.name, text: a.text as string }));
  const out: AgentExtras = {};
  if (mentions.length) out.mentions = mentions.map((m) => ({ id: m.id, title: m.title }));
  if (imageUrls.length) out.imageUrls = imageUrls;
  if (docTexts.length) out.docTexts = docTexts;
  return out;
}
